export enum QueryKeys {
  PAGE_SIZE = "pageSize",
  PAGE_INDEX = "pageIndex",
  FILTER = "filter",
  ORDER_BY = "sort",
  START_DATE = "startDate",
  END_DATE = "endDate",
  TOKEN = "token",
}
